export default __webpack_public_path__ + "static/media/3_ChestOfGems.4f68161b.png";